import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrintAssetLinkComponent } from './print-asset-link/print-asset-link.component';
import { PrintAssestLandingPageComponent } from './print-assest-landing-page/print-assest-landing-page.component';

const routes: Routes = [

  {
    path: '', component: PrintAssetLinkComponent,
    children: [
      { path: 'printBuildingAssetQRDetail', component: PrintAssestLandingPageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrintAssetsQRRoutingModule { }
